import { jsx, jsxs } from "react/jsx-runtime";
import { c as classNames } from "../../../../index-e71f83b5.js";
import { useState, useCallback } from "react";
import { COMMON_CLASSNAME } from "../../../constants.js";
import { sass } from "../../../../sass/sass.js";
import FlashBadge from "../../info/FlashBadge/FlashBadge.js";
import FlashSpinner from "../../info/FlashSpinner/FlashSpinner.js";
import FlashButtonGeneric from "../FlashButtonGeneric.js";
import { FlashButtonSizes } from "./constants.js";
import "../../../../_commonjsHelpers-0c53d963.js";
import "../../../../utils-65a8d69b.js";
import "../../../../index-5e4e4f4b.js";
import "../../../../axios-5f69b112.js";
import "../../../../Button-dadda608.js";
import "../../../../hooks/useInsights/useInsights.js";
import "../../../../utils/noOp.js";
import "../../../../hooks/useLogger/constants.js";
import "../../../../hooks/useLogger/useLogger.js";
import "../../../../hooks/useLogger/LoggerContext.js";
import "../../../../hooks/useLogger/types.js";
import "../../../../hooks/useInsights/InsightsContext.js";
import "../../../../hooks/useInsights/useInsightsImpression.js";
import "../../../../index-2d889c01.js";
import "../../../../hooks/useInsights/utils.js";
import "../../../../utils/invokeFn.js";
function FlashButton(props) {
  const {
    id,
    type = "button",
    onClick,
    btnRef,
    color = "primary",
    isPressed,
    isSelected,
    disabled,
    isBlock,
    LeadingIcon,
    iconFontSize,
    ActionIcon,
    onClickActionIcon,
    isLoading,
    badgeText,
    isRounded,
    tightRadius,
    removePadding,
    removeBorder,
    children,
    align = "center",
    className,
    size,
    onMouseDown,
    analytics = {}
  } = props, isIconOnlyBtn = LeadingIcon && !children, isSmall = size === FlashButtonSizes.SMALL, isLarge = size === FlashButtonSizes.LARGE, usedFontSize = iconFontSize || sass.typography.flash.semantic.font.label[isSmall ? "s" : "m"].size, [buttonContentDimensions, setButtonContentDimensions] = useState(), buttonContentRef = useCallback(
    (node) => {
      if (!node || isLoading)
        return;
      const { height, width } = node.getBoundingClientRect();
      setButtonContentDimensions({ height, width });
    },
    [isLoading]
  );
  return /* @__PURE__ */ jsx("span", { className: COMMON_CLASSNAME, children: /* @__PURE__ */ jsx(
    FlashButtonGeneric,
    {
      id,
      "data-testid": id,
      type,
      onClick,
      onMouseDown,
      btnRef,
      color,
      disabled,
      analytics,
      className: classNames(
        "flash-button",
        {
          "btn-pressed": isPressed,
          "btn-selected": isSelected,
          "p-0": removePadding,
          "rounded-pill": isRounded && !isIconOnlyBtn,
          "rounded-circle": isRounded && isIconOnlyBtn,
          "border-0": removeBorder,
          "rounded-0": removeBorder,
          "rounded-1": !removeBorder && !isRounded && tightRadius,
          "fs-label-s": isSmall,
          [`btn-${size}`]: !!size,
          "px-flash-200": !removePadding && !isIconOnlyBtn && !size,
          "py-flashd-088": !removePadding && isSmall,
          "py-flashd-188": !removePadding && !size,
          "py-flashd-238": !removePadding && isLarge,
          // keep button squared for each button size
          "px-flashd-088": !removePadding && isIconOnlyBtn && isSmall,
          "px-flashd-188": !removePadding && isIconOnlyBtn && !size,
          "px-flashd-238": !removePadding && isIconOnlyBtn && isLarge
        },
        className
      ),
      isBlock,
      children: /* @__PURE__ */ jsxs(
        "span",
        {
          ref: buttonContentRef,
          className: classNames("w-100 d-flex gap-flash-050 align-items-center", {
            "justify-content-center": isLoading
          }),
          style: {
            minWidth: isLoading ? `${buttonContentDimensions == null ? void 0 : buttonContentDimensions.width}px` : void 0,
            minHeight: isLoading ? `${buttonContentDimensions == null ? void 0 : buttonContentDimensions.height}px` : void 0
          },
          children: [
            isBlock && align !== "start" && /* @__PURE__ */ jsx("span", { className: "flex-fill" }),
            isLoading && /* @__PURE__ */ jsx(FlashSpinner, { size: usedFontSize }),
            !isLoading && LeadingIcon && /* @__PURE__ */ jsx(ButtonIconWrapper, { children: /* @__PURE__ */ jsx(LeadingIcon, { height: usedFontSize, width: usedFontSize }) }),
            !isLoading && children && /* @__PURE__ */ jsx("span", { children }),
            !isLoading && badgeText && /* @__PURE__ */ jsx(FlashBadge, { text: badgeText, className: "px-flash-100 py-flash-050 mt-nflash-025 mb-nflash-050" }),
            isBlock && align === "start" && /* @__PURE__ */ jsx("span", { className: "flex-fill" }),
            !isLoading && ActionIcon && /* @__PURE__ */ jsx(ButtonIconWrapper, { onClick: onClickActionIcon, children: /* @__PURE__ */ jsx(ActionIcon, { height: usedFontSize, width: usedFontSize }) }),
            isBlock && align === "center" && /* @__PURE__ */ jsx("span", { className: "flex-fill" })
          ]
        }
      )
    }
  ) });
}
function ButtonIconWrapper(props) {
  const { children, onClick } = props;
  return /* @__PURE__ */ jsx("span", { className: "d-inline-flex", onClick, role: onClick ? "button" : void 0, children });
}
export {
  FlashButton as default
};
//# sourceMappingURL=FlashButton.js.map
